import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'
import { cn } from '@/lib/utils'

interface AuthCardLayoutProps {
  title: string
  subtitle?: string
  backTo?: string
  children: ReactNode
}

export function AuthCardLayout({ title, subtitle, backTo, children }: AuthCardLayoutProps) {
  return (
    <div className="flex min-h-0 flex-1 flex-col items-center justify-center bg-[#fcfcfc] px-4 py-8">
      <div className="mx-auto w-full max-w-[543px]">
        <div className="relative rounded-[26px] bg-white p-10 shadow-none">
          {backTo && (
            <Link
              to={backTo}
              className="text-foreground hover:text-primary absolute top-10 left-6 flex items-center gap-1 text-sm transition-colors"
              aria-label="Retour"
            >
              <ArrowLeft className="h-5 w-5" />
            </Link>
          )}
          <img
            src="/logo-dark.svg"
            alt="EBIM"
            width={137}
            height={113}
            className="mx-auto mb-10 h-[113px] w-[137px] object-contain"
          />
          <h1
            className={cn(
              'text-foreground text-center text-2xl leading-tight font-medium',
              !subtitle && 'mb-10'
            )}
          >
            {title}
          </h1>
          {subtitle && (
            <p className="text-foreground mx-auto mt-2 mb-10 max-w-[463px] text-center text-base font-normal">
              {subtitle}
            </p>
          )}
          {children}
        </div>
      </div>
    </div>
  )
}
